import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { iBisViewComponent } from '@dohu/ibis-common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProxyService } from '../../service/proxy.service';

@Component({
	selector: 'app-patient-files',
	templateUrl: './patient-files.component.html'
})
export class PatientFilesComponent extends iBisViewComponent implements OnChanges {

	@Input() patientId: string;
	@Input() height: any = '100%';
	@Input() allowUpload = true;
	@Input() allowDelete = false;

	files: any[] = [];

	constructor(public proxy: ProxyService) {
		super(null, proxy.lg, proxy.iui, proxy.activatedRoute);
		this.key = 'patient-files';
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.patientId?.currentValue) {
			this.loadFiles(changes.patientId.currentValue);
		} else if (changes.patientId && !changes.patientId.currentValue) {
			this.files = [];
		}
	}

	onDownloadClick = (ev: any) => {
		this.proxy.file.download(ev.row.data.id).then(() => {
			notify(this.L('FILE_DOWNLOADED', null), 'success', 2000);
		}, () => {
			notify(this.L('DOWNLOAD_ERROR', null), 'error', 3000);
		});
	};

	onPreviewClick = (ev: any) => {
		this.proxy.file.view(ev.row.data.id);
	};

	onDeleteFileClick = (ev: any) => {
		confirm(this.L('DELETE_QUESTION'), this.L('CONFIRM_DELETE')).then((response) => {
			if (response) {
				this.proxy.file.deleteFile(ev.row.data.id).then(() => {
					this.loadFiles(this.patientId);
				}, (error) => {
					this.lg.showError(error);
				});
			}
		});
	};

	toolbarPreparing(event: any) {
		super.toolbarPreparing(event, false);
		if (this.allowUpload) {
			event.toolbarOptions.items.unshift({
				widget: 'dxButton',
				options: {
					icon: 'plus', hint: this.L('ADD_FILE'), onClick: () => {
						this.proxy.file.upload(this.patientId).then((res: any) => {
							if (res) {
								this.loadFiles(this.patientId);
								notify(this.L('FILE_UPLOADED'), 'success', 2000);
							}
						}, () => {
							notify(this.L('UPLOAD_ERROR'), 'error', 3000);
						});
					}
				},
				location: 'after'
			});
		}
	}

	private loadFiles(patientId: string) {
		this.proxy.ds.getPatientAllFiles(patientId).then((res: any) => {
			this.files = res ?? [];
		}, err => this.lg.showError(err));
	}
}
